import { apiSlice } from "./apiSlice";
import { PAYMENTS_URL } from "../constants";

const paymentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPayment: builder.mutation({
      query: (data) => ({
        url: `${PAYMENTS_URL}/createPayment`,
        method: "POST",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    getPayments: builder.query({
      query: (data) => ({
        url: `${PAYMENTS_URL}/getPayments?${data.query ? data.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    editPayment: builder.mutation({
      query: (data) => ({
        url: `${PAYMENTS_URL}/editPayment/${data.paymentId}`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useCreatePaymentMutation,
  useGetPaymentsQuery,
  useEditPaymentMutation,
} = paymentsApiSlice;
